import { render } from "./CardControl.vue?vue&type=template&id=615048c8&scoped=true"
import script from "./CardControl.vue?vue&type=script&lang=js"
export * from "./CardControl.vue?vue&type=script&lang=js"

import "./CardControl.vue?vue&type=style&index=0&id=615048c8&scoped=true&lang=css"

import exportComponent from "C:\\Deployment\\Member Portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-615048c8"]])

export default __exports__